import { useState } from "react";
import { api, apiError } from "@/lib/api";
import { PageHeader } from "@/components/StatCard";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";
import { Section, Loading, Empty, useFetch } from "./_shared";

const asList = (arr) => (arr || []).map((x) => (typeof x === "string" ? { name: x } : x));

export default function Categories() {
  const { data, loading, reload } = useFetch("/admin/categories");
  const { data: vis, reload: reloadVis } = useFetch("/admin/marketing/visibility");
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);
  if (loading) return <Loading />;
  const builtin = asList(data?.builtin); const custom = asList(data?.custom);

  const create = async () => {
    if (!name.trim()) return;
    setBusy(true);
    try { await api.post("/admin/categories", { name: name.trim().toLowerCase() }); setName(""); toast.success("Kategorie angelegt."); await reload(); }
    catch (err) { toast.error(apiError(err)); } finally { setBusy(false); }
  };
  const del = async (n) => { try { await api.delete(`/admin/categories/${encodeURIComponent(n)}`); await reload(); } catch (err) { toast.error(apiError(err)); } };
  const toggleVis = async (v) => { try { await api.put("/admin/marketing/visibility", { visible: v }); await reloadVis(); } catch (err) { toast.error(apiError(err)); } };

  return (
    <div className="space-y-5">
      <PageHeader eyebrow="Admin" title="Kategorien" subtitle="Taxonomie & Marketing-Sichtbarkeit." />
      <Section title="Marketing-Sichtbarkeit">
        <label className="flex items-center justify-between gap-3"><span className="text-sm text-foreground">Marketing-Personas öffentlich sichtbar</span><Switch checked={!!vis?.visible} onCheckedChange={toggleVis} data-testid="admin-cat-visibility" /></label>
      </Section>
      <Section title="Eigene Kategorien" testId="admin-cat-custom"
        action={<div className="flex gap-2"><Input value={name} onChange={(e) => setName(e.target.value)} placeholder="name_slug" className="h-8 w-40" data-testid="admin-cat-name" /><Button size="sm" className="rounded-full" disabled={busy} onClick={create} data-testid="admin-cat-create"><Plus className="h-4 w-4" /></Button></div>}>
        {custom.length === 0 ? <Empty text="Keine eigenen Kategorien." /> : (
          <div className="flex flex-wrap gap-2">
            {custom.map((c) => (
              <span key={c.name} className="inline-flex items-center gap-1.5 rounded-full border border-border bg-background px-3 py-1 text-sm text-foreground">
                {c.name}{c.count != null ? ` (${c.count})` : ""}
                <button onClick={() => del(c.name)} data-testid={`admin-cat-del-${c.name}`} className="text-rose-500"><Trash2 className="h-3.5 w-3.5" /></button>
              </span>
            ))}
          </div>
        )}
      </Section>
      <Section title="Eingebaute Kategorien">
        <div className="flex flex-wrap gap-2">
          {builtin.map((c) => <span key={c.name} className="rounded-full bg-secondary px-3 py-1 text-sm text-muted-foreground">{c.name}{c.count != null ? ` (${c.count})` : ""}</span>)}
        </div>
      </Section>
    </div>
  );
}
